import { Navigate, useLocation, useParams } from "react-router-dom";

/** Sends a former Test Scripts or Test Replays link to the Test Cases page, keeping its query so its modal still opens. */
export function TestCasesRedirect() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  if (!id) throw new Error("Project ID is required");
  return (
    <Navigate to={{ pathname: `/muggleTestV0/dashboard/projects/${id}/testcases`, search: location.search }} replace />
  );
}
